module.exports = __webpack_public_path__ + "img/12.4c7998d5.png";